import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Router } from '@angular/router';
@Component({
    selector: 'app-status',
    template: `
    <div>
      <img src="assets/images/namc_status_{{this.colorCode}}.png" alt="edit" style="width:12px;height:13px" /> 
    </div>
    `,
    standalone: false // NOSONAR
})
export class StatusBtnCellrender implements ICellRendererAngularComp {

    refresh(params: ICellRendererParams): boolean {
        throw new Error(
        `Error while refreshing renderer component. INFO-${params}`
        );
    }

    protected params: any;
    colorCode: any;
    constructor( private readonly router : Router) {}

    agInit(params: any): void {
      this.params = params;
      this.colorCode = this.params.data.orderStatus;
    }
    
    }
